import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { useDocumentLibraryStorage } from './useDocumentLibraryStorage';
export function useUpdatePermissions() {
    const { updateFilePermissions } = useDocumentLibraryStorage();
    const updatePermissions = ({ id, permissions, onSuccess }) => {
        return new Promise((resolve, reject) => {
            updateFilePermissions({ fileId: id, permissions: permissions })
                .then(() => {
                onSuccess && onSuccess();
                resolve();
            })
                .catch((error) => {
                handleErrorDialog(error);
                reject();
            });
        });
    };
    return {
        updatePermissions,
    };
}
